function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m168 481v-441h272v440",
  fill: "#5f4d37"
}), /*#__PURE__*/React.createElement("path", {
  d: "m192 479v-415h224v416",
  fill: "#ff931e"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#a0815c",
  height: 144,
  rx: 8,
  width: 144,
  x: 72,
  y: 336
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 400-24-16-24 16v-64h48z",
  fill: "#ffda44"
}), /*#__PURE__*/React.createElement("path", {
  d: "m96 432h24v24h-24z",
  fill: "#e0e0e2"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 376,
  cy: 264,
  fill: "#e0e0e2",
  r: 16
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m120 424h-24a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-8 24h-8v-8h8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 424h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m152 448h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m463 472h-15v-432a8 8 0 0 0 -8-8h-272a8 8 0 0 0 -8 8v288h-80a16.021 16.021 0 0 0 -16 16v128h-48a8 8 0 0 0 0 16h447a8 8 0 0 0 0-16zm-335-128h32v41.05l-11.56-7.71a8.026 8.026 0 0 0 -8.88 0l-11.56 7.71zm80 128h-128v-128h32v56a8.009 8.009 0 0 0 12.44 6.66l19.56-13.05 19.56 13.05a8.026 8.026 0 0 0 4.44 1.34 8.015 8.015 0 0 0 8-8v-56h32l.01 128zm200 0h-184v-128a16.021 16.021 0 0 0 -16-16h-8v-256h208zm24 0h-8v-408a8 8 0 0 0 -8-8h-224a8 8 0 0 0 -8 8v264h-8v-280h256z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m496 472h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m336 272h17.376a24 24 0 1 0 0-16h-17.376a8 8 0 0 0 0 16zm40-16a8 8 0 1 1 -8 8 8.009 8.009 0 0 1 8-8z"
})));

var SvgDelivered = function SvgDelivered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelivered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivered.ab8c10a3.svg";
export { ForwardRef as ReactComponent };